// Vendor libraries
import { HttpClientJsonpModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
// Ngrx reducers
import { getLogger } from 'NewAngular/state/logger';
import { rootReducer } from './state/fund-chart.reducer';
// Modules
import { ChartsSharedModule } from 'ChartApp/ts/features/charts-shared/charts-shared.module';
import { FundChartPageSharedModule } from 'ChartApp/ts/features/fund-chart-page-shared/fund-chart-page-shared.module';
import { FundamentalChartModule } from 'ChartApp/ts/features/fundamental-chart/fundamental-chart.module';
import { LegacyAssetConversionCheckerModule } from 'ConverterApp/features/legacy-asset-conversion-checker/legacy-asset-conversion-checker.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { FoldersSharedModule } from 'FoldersApp/features/folders-shared/app.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { SimpleDropdownModule } from 'NewAngular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { CheckboxGroupModule } from 'NewAngular/features/components/inputs/checkbox-group/checkbox-group.module';
import { ColorPickerModule } from 'NewAngular/features/components/inputs/color-picker/color-picker.module';
import { SimpleInputModule } from 'NewAngular/features/components/inputs/simple-input/simple-input.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ChartEmbedModalModule } from 'NewAngular/features/components/modals/chart-embed-modal/chart-embed-modal.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { PromptModalModule } from 'NewAngular/features/components/modals/prompt-modal/prompt-modal.module';
import { SharingModalModule } from 'NewAngular/features/components/modals/sharing-modal/sharing-modal.module';
import { TemplateModalModule } from 'NewAngular/features/components/modals/template-modal/template-modal.module';
import { UrlShortenerModalModule } from 'NewAngular/features/components/modals/url-shortener-modal/url-shortener-modal.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { PageErrorMessageModule } from 'NewAngular/features/components/page-error-message/page-error-message.module';
import { OpenItemModalModule } from 'NewAngular/features/components/saved-items/open-item-modal/open-item-modal.module';
import { SavedItemDropdownModule } from 'NewAngular/features/components/saved-items/saved-item-dropdown/saved-item-dropdown.module';
import { SideMenuModule } from 'NewAngular/features/components/side-menu/side-menu.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { StoreDevtoolsModule } from 'NewAngular/state/store-devtools/store-devtools.development';
import { ModuleUpsellModule } from 'SecuritiesApp/ts/features/module-upsell/module-upsell.module';
import { PdfTitleModalModule } from 'NewAngular/features/components/pdf-title-modal/pdf-title-modal.module';
import { LoadingModalModule } from 'NewAngular/features/components/modals/loading-modal/loading-modal.module';
import { DeleteModalComponent } from 'NewAngular/features/components/delete-modal/delete-modal.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { PageToastMessagesComponent } from 'NewAngular/features/components/toast-messages/page-toast-messages.component';
import { FundChartAISummaryModalComponent } from './components/fund-chart-ai-summary-modal/fund-chart-ai-summary-modal.component';
import { FundChartPageComponent } from './components/fund-chart-page/fund-chart-page.component';
// Pipes
import { RadioButtonGroupModule } from 'NewAngular/features/components/inputs/radio-button-group/radio-button-group.module';
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
import { GetOwnerDisplayNamePipeModule } from 'SharingApp/ts/pipes/get-owner-display-name.module';
import { GetSharingTooltipMessagePipeModule } from 'SharingApp/ts/pipes/get-sharing-tooltip-message.module';
import { IsSharedWithOthersPipeModule } from 'SharingApp/ts/pipes/is-shared-with-others-pipe.module';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ngrx/store-devtools";
import * as i3 from "@ngrx/store";
export class FundChartPageModule {
}
FundChartPageModule.ɵfac = function FundChartPageModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartPageModule)(); };
FundChartPageModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: FundChartPageModule, bootstrap: [FundChartPageComponent, TopBarNavComponent] });
FundChartPageModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [
        // Jsonp module must be imported before ConfigModule to
        // prevent X-CSRFToken header from being included in
        // jsonp requests https://github.com/angular/angular/issues/47312
        HttpClientJsonpModule,
        BrowserModule,
        ChartEmbedModalModule,
        ChartsSharedModule,
        CheckboxGroupModule,
        ColorPickerModule,
        ColorPickerModule,
        ConfigModule,
        ConfirmModalModule,
        DeleteModalComponent,
        DisabledModule,
        FeatureNeededModule,
        FoldersSharedModule,
        FormsModule,
        FundamentalChartModule,
        FundChartAISummaryModalComponent,
        FundChartPageSharedModule,
        GetOwnerDisplayNamePipeModule,
        GetSharingTooltipMessagePipeModule,
        IconModule,
        IsSharedWithOthersPipeModule,
        LegacyAssetConversionCheckerModule,
        LoadingModalModule,
        LoadingSymbolModule,
        ModalBaseModule,
        ModuleUpsellModule,
        NavigationModule,
        OpenItemModalModule,
        PageErrorMessageModule,
        PdfTitleModalModule,
        PromptModalModule,
        RadioButtonGroupModule,
        RouterModule.forRoot([], { useHash: true }),
        SavedItemDropdownModule,
        SharingModalModule,
        SideMenuModule,
        SimpleDropdownModule,
        SimpleInputModule,
        SingleSelectDropdownModule,
        StoreDevtoolsModule,
        StoreModule.forRoot({ reducers: rootReducer }, { metaReducers: getLogger() }),
        TemplateModalModule,
        PageToastMessagesComponent,
        TooltipModule,
        UrlShortenerModalModule] });
